export default "__VITE_ASSET__DiVN$$hG__"